import {
    SET_SIDEBAR_BLOCK_BOUNDS,
    SET_SIDEBAR_BLOCK_ID,
    SET_SIDEBAR_OPEN_BLOCK,
} from '../../mutation-types';


export default {
    [SET_SIDEBAR_OPEN_BLOCK](state, { openBlockId }) {
        state.openBlockId = openBlockId;
    },
    [SET_SIDEBAR_BLOCK_ID](state, { blockId }) {
        state.blockIds = [...state.blockIds, blockId];
    },
    [SET_SIDEBAR_BLOCK_BOUNDS](state, { blockId, bounds }) {
        state.blockBounds = {
            ...state.blockBounds,
            [blockId]: bounds,
        };
    },
};
